import moment from 'moment';
import Vue from 'vue'
import GlobalStore from '../GlobalStore';
import {
    WEB_PLATFORM_TYPE,
} from "../Constants";


class Util {
    static initialStrFromDay(day){
        var str = "";
        switch(day){
            case 0:
                str = "일";
                break;
            case 1:
                str = "월";
                break;
            case 2:
                str = "화";
                break;
            case 3:
                str = "수";
                break;
            case 4:
                str = "목";
                break;
            case 5:
                str = "금";
                break;
            case 6:
                str = "토";
                break;
        }
        return str
    }

    
    static checkAppLinkPageShow(action = () => {}, param0 = null, param1 = null, param2 = null){
        const device = Vue.$cookies.get('device');
        const userAgent = navigator.userAgent;
        const condition =
            process.env.NODE_ENV === 'production' &&
                        (userAgent.match(/iPhone|iPad|iPod/i) || userAgent.match(/android/i)) && 
                        (device !== 'android' && device !== 'ios') && 
                        !Vue.prototype.$hasOwnProperty(sessionStorage, 'IS_SHOW_NOW_DETAIL_APPLINK_POP')
        if (condition) {
            GlobalStore.setSchemes(action, param0, param1, param2);
            return true;
        } else {
            return false;
        }
    }

    static setPhoneFormatter(el){
        var patternStr = "-";
        var patternLocationArr = [4, 9];//몇번째 칸인지 나타냄
        var keyDownLength = 0;
        //var el = document.getElementById(id);
        el.addEventListener("keydown", function(e){
            keyDownLength = e.currentTarget.value.length ;
        });

        function checkAddedAndNotMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] && !isNaN(text[patternLocationArr[i] - 1])){
                    return true;
                }
            }
            return false;
        }

        function checkAddedAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] - 1){
                    return true;
                }
            }
            return false;
        }

        function checkBackSpaceAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i]){
                    return true;
                }
            }
            return false;
        }

        el.addEventListener("keyup", function(e){

            var target = e.currentTarget;
            var text = target.value;
            var pattern = /^(\d{1,3}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)$/g;
            var textMaxIndex = text.length - 1
            var isBackspace = false;
            if(target.selectionStart != text.length) return true;

            if(text.length == keyDownLength - 1) isBackspace = true;

            if(!pattern.test(text)){
                if(checkAddedAndNotMatched(text)){
                    target.value = text.substr(0, textMaxIndex) + patternStr + text[textMaxIndex];
                }else {
                    target.value = text.substr(0, textMaxIndex);
                }
            }else{
                if(checkAddedAndMatched(text) && !isBackspace){
                    target.value = text + patternStr;
                }else if(isBackspace && checkBackSpaceAndMatched(target.value)){
                    target.value = target.value.substr(0, textMaxIndex);
                }
            }
        })
    }

    static setCardNumberFormmater(el){
        this.setFormmatter(el, '-', [5, 10, 15], () => {return /^(\d{1,4}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)(-|$)(\d{1,4}|$)$/g;});
    }

    static showChannelTalk() {
        const device = Vue.$cookies.get('device');
        if(device === 'ios' || device === 'android'){
            Util.showBrowser('https://soccerhow.channel.io/home')
        }else {
            window.open('https://soccerhow.channel.io/home');
        }
    }

    static isApp(){
        const device = Vue.$cookies.get('device');
        return device === 'ios' || device === 'android';
    }

    static setCardMMYYFormmater(el){
        this.setFormmatter(el, '/', [3], () => {return /^(\d{1,2}|$)(\/|$)(\d{1,2}|$)$/g;});
    }

    static setYearDotMonthFormmater(el){
        this.setFormmatter(el, '.', [5], () => {return /^(\d{1,4}|$)(.|$)(\d{1,2}|$)$/g;});
    }

    static setYYYYMMDDFormmater(el){
        this.setFormmatter(el, '/', [5, 8], () => {return /^(\d{1,4}|$)(\/|$)(\d{1,2}|$)(\/|$)(\d{1,2}|$)$/g;});
    }

    static setFormmatter(el, patternStr, patternLocationArr, pPattern){
        var keyDownLength = 0;
        //var el = document.getElementById(id);
        el.addEventListener("keydown", function(e){
            keyDownLength = e.currentTarget.value.length ;
        });

        function checkAddedAndNotMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] && !isNaN(text[patternLocationArr[i] - 1])){
                    return true;
                }
            }
            return false;
        }

        function checkAddedAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i] - 1){
                    return true;
                }
            }
            return false;
        }

        function checkBackSpaceAndMatched(text){
            for(var i = 0; i < patternLocationArr.length; i++){
                if(text.length == patternLocationArr[i]){
                    return true;
                }
            }
            return false;
        }

        el.addEventListener("keyup", function(e){
            var target = e.currentTarget;
            var text = target.value;
            var pattern = pPattern();
            var textMaxIndex = text.length - 1
            var isBackspace = false;
            if(target.selectionStart != text.length) return true;

            if(text.length == keyDownLength - 1) isBackspace = true;

            if(!pattern.test(text)){
                if(checkAddedAndNotMatched(text)){
                    target.value = text.substr(0, textMaxIndex) + patternStr + text[textMaxIndex];
                }else {
                    target.value = text.substr(0, textMaxIndex);
                }
            }else{
                if(checkAddedAndMatched(text) && !isBackspace){
                    target.value = text + patternStr;
                }else if(isBackspace && checkBackSpaceAndMatched(target.value)){
                    target.value = target.value.substr(0, textMaxIndex);
                }
            }
        })
    }

    static setDateToMD(dateStr){
        if(!dateStr) return '';
        const month = parseInt(dateStr.substr(5, 2));
        const date = parseInt(dateStr.substr(8, 2));

        return month + '/' + date;
    }


    static copyToClipboard(copyStr){
        window.copyToClipboard(copyStr);
    }

    static once = (fn) => {
        let done = false;
        return async (...args) => {
            if (!done) {
                done = true;
                await fn(...args);
                done = false;
            }
        }
    }

    static getYYYYDotMMDotDDDayStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY.MM.DD');
        showDateStr += "(" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    static getMMSlashDDDayStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('MM/DD');
        showDateStr += " (" + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    //2024년 10월 11일 금요일
    static getMMDDDayHangulStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY년 MM월 DD일');
        showDateStr += ' ' + this.initialStrFromDay(momentInstance.day()) + "요일";
        return showDateStr
    }

    static getMMDDDayHangulStrExceptionYYYY(dateStr) {
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('MM월 DD일');  // 년도를 제외한 월, 일 형식
        showDateStr += ' ' + this.initialStrFromDay(momentInstance.day()) + "요일";  // 요일 추가
        return showDateStr;
    }

    //9월 16일
    static getMDDHangulStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
        var showDateStr = momentInstance.format('M월 DD일');
        return showDateStr
    }

    static getMMHangulStr(dateStr){
        return moment(dateStr, "YYYY-MM").format('YYYY년 MM월');
    }

    static getYYYMMDDHangulStr(dateStr){
        return moment(dateStr, "YYYY-MM-DD").format('YYYY년 MM월 DD일');
    }

    static getMMDDDayBracketStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD");
        var showDateStr = momentInstance.format('YYYY년 MM월 DD일');
        showDateStr += ' (' + this.initialStrFromDay(momentInstance.day()) + ")";
        return showDateStr
    }

    //오후 6:00 ~ 7:30
    static getAmPmTimeStr(begin_time, end_time){
        const begin_time_int = begin_time.substr(0, 2);
        const end_time_int = end_time.substr(0, 2);

        let begin_time_str = begin_time;
        let end_time_str = end_time;

        let is_afternoon = false;

        if(begin_time_int > 12) {
            is_afternoon = true;
            begin_time_str = (begin_time_int - 12) + begin_time.substr(2, 3);
        }
        if(end_time_int > 12) end_time_str = (end_time_int - 12) + end_time.substr(2, 3);

        return (is_afternoon ? '오후' : '오전') + ' ' + begin_time_str + ' ~ ' + end_time_str;
    }

    //2024년 4월 3일 수요일 18:02
    static getMMDDDayHHmmBracketStr(dateStr){
        var momentInstance = moment(dateStr, "YYYY-MM-DD HH:mm:ss");
        var showDateStr = momentInstance.format('YYYY년 M월 D일');
        showDateStr += ' (' + this.initialStrFromDay(momentInstance.day()) + ")";
        showDateStr += momentInstance.format('HH:mm');
        return showDateStr
    }

    static getTimeGapStr(begin_date_time, end_date_time){
        const startMoment = moment(begin_date_time, "YYYY-MM-DD HH:mm:ss");
        const endMoment = moment(end_date_time, "YYYY-MM-DD HH:mm:ss");
        const diff_minutes = endMoment.diff(startMoment,'minutes');
        const minutes = diff_minutes % 60;
        const hour = parseInt(diff_minutes / 60);
        const str = (hour > 0 ? hour + '시간 ' : '') + (minutes > 0 ? minutes + '분' : '');
        return str;
    }

    static getWebPlatForm(){
        if( /Android/i.test(navigator.userAgent)) {
            return WEB_PLATFORM_TYPE.ANDROID;
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            return WEB_PLATFORM_TYPE.IOS;
        } else {
            return WEB_PLATFORM_TYPE.OTHER;
        }
    }

    static showBrowser(url){
        url = url.replace('/?', '?');
        const device = Vue.$cookies.get('device');
        if(device === 'android'){
            window.Android.showBrowser(url);
        }else if(device === 'ios'){
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({cmd : 'showBrowser', url : url});
        }
    }

    static toCurrencyString(intBodyWorth) {
        let bodyWorth = '';
         if (intBodyWorth < 1000) {
            bodyWorth = intBodyWorth.toLocaleString('kr-KR')
        } else if (intBodyWorth < 10000){
            bodyWorth = (intBodyWorth / 1000).toFixed(1) + " 천"
        } else{
            bodyWorth = (intBodyWorth / 10000).toFixed(1) + " 만"
        }
        return bodyWorth;
    }

    static setDuesType(dues, isSchedule = false) {
        const transNumber = parseInt(dues)
        if (isNaN(transNumber) && isSchedule || dues == 0 && isSchedule) {
            return '무료'
        }
        if (transNumber <= 9999) {
            return Math.floor(transNumber / 1000) + '.' + Math.floor((transNumber % 1000) / 100) + '천';
        } else if (transNumber < 99999) {
            return Math.floor(transNumber / 10000) + '.' + Math.floor((transNumber % 10000) / 1000) + '만';
        } else if (transNumber <= 999999) {
            return Math.floor(transNumber / 10000) + '.' + Math.floor((transNumber % 10000) / 1000) + '만';
        } else if (transNumber <= 9999999) {
            return Math.floor(transNumber / 10000) + '만'
        }
        else if (isNaN(transNumber)) {
            return 0 + '원'
        }
    }

    static sendEventClick(key){
        // console.log(key)
        window.gtag('event', key);
    }

    static removeLink(contents) {
        if(!contents) return contents;
        const urlPattern = /(https?:\/\/[^\s]+)/g;
        let result = contents.replace(urlPattern, '')
        result = result.replace(/[\r\n]+/g, ' ').trim();
        return result
    }

    static removeYoutubeLink(contents){
        if(!contents) return contents;
        return contents.replace(/https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is, '');
    }

    static checkYoutubeLink(str){
        const pattern = /https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is;
        return pattern.test(str);
    }

    static getYoutubeLinkArr(str){
        const pattern = /https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is;
        return str.match(pattern);
    }

    static getYoutubeThumbnail(contents){
        const pattern = /https?:\/\/youtu.be\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https?:\/\/(?:www\.)?youtube.com\/watch\?v=(\S+)\r?\n?/is;
        const youtubeArr = pattern.exec(contents) ?? [];
        let firstYoutube = "";

        if(youtubeArr[1]){
            const key_arr = youtubeArr[1].split('?');
            firstYoutube = 'https://img.youtube.com/vi/' + key_arr[0] + '/0.jpg';
        }else if(youtubeArr[2]){
            const key_arr = youtubeArr[2].split('?');
            firstYoutube = 'https://i.ytimg.com/vi/' + key_arr[0] + '/sd2.jpg';
        }else if(youtubeArr[3]){
            const key_arr = youtubeArr[3].split('&');
            firstYoutube = 'https://img.youtube.com/vi/' + key_arr[0] + '/0.jpg';
        }

        return firstYoutube;
    }

    static checkIsLatestVersion(){
        const app_version = Vue.$cookies.get('appv');
        const device = Vue.$cookies.get('device');

        let is_latest_version = true;

        if(!app_version) return is_latest_version;

        if(device === 'android'){
            is_latest_version = parseInt(app_version) >= 12;
        }else if(device === 'ios'){
            is_latest_version = parseInt(app_version) >= 17;
        }

        return is_latest_version
    }

    static transPosition = function(position) {
        if(position === null || position === undefined)
            return null;

        const data = {
            'CF':"CF",
            'LW':"WF",
            'RW':"WF",
            'WF':"WF",
            'LWF': "WF",
            'RWF': "WF",
            'MF':"CM",
            'SS':"SS",
            'AM':"AM",
            'CM':"CM",
            'LM':"WM",
            'RM':"WM",
            'WM':"WM",
            'DM':"DM",
            'LWB':"WB",
            'RWB':"WB",
            'WB': "WB",
            'LB':"FB",
            'RB':"FB",
            'FB':"FB",
            'CB':"CB",
            'FW':"CF",
            'GK': 'GK'
        };
        if(position in data) {
            return data[position];
        }
        return null;
    }

    static getMddhhTimeStr(begin_date_time, end_date_time){
        const begin_date_moment = moment(begin_date_time, "YYYY-MM-DD HH:mm:ss");
        const end_date_moment = moment(end_date_time, "YYYY-MM-DD HH:mm:ss");
        const str = parseInt(begin_date_moment.format('MM')) + '월 ' + begin_date_moment.format('DD') + '일 ' + begin_date_moment.format('HH:00') + ' ~ ' + end_date_moment.format('HH:00');
        return str;
    }

}
//
// export function getMMDDDayStr(dateStr){
//     var momentInstance = moment(dateStr, "YYYY-MM-DD");
//     var showDateStr = momentInstance.format('MM월 DD일');
//     showDateStr += "(" + initialStrFromDay(momentInstance.day()) + ")";
//     return showDateStr
// }
//
// export function getMDDayStr(dateStr){
//     var momentInstance = moment(dateStr, "YYYY-MM-DD");
//     var showDateStr = momentInstance.format('M월 D일');
//     showDateStr += "(" + initialStrFromDay(momentInstance.day()) + ")";
//     return showDateStr
// }

export default Util
